const MenuType={
	MENU_BAR:'menuBar', MAIN_MENU:'mainMenu', FILTERS:'filters',
	AVAILABLE_PRICES_FILTER:'availablePricesFilter', STATUS_FILTER:'statusFilter',
	BEDROOMS_FILTER:'bedroomsFilter', HOUSE_TYPE_FILTER:'houseTypeFilter', PLOT_SEARCH:'plotSearch',
	SITE_PICKER:'sitePicker', PLOT_MORE_INFORMATION:'plotMoreInformation',
	BROCHURE_GENERATION:'brochureGeneration', FAVOURITES:'favourites', IMAGE_VIEWER:'imageViewer',
	PRIVACY_POLICY:'privacyPolicy', BROCHURES:'brochures',
	PLOT_DETAILED_INFORMATION:'plotDetailedInformation',
	FEATURES_FILTER:'featuresFilter'
};
export default MenuType;